/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,

} from 'mdb-react-ui-kit';

import { isTokenPresent } from '../utils/auth';
import Attribution from '../utils/Interface/Attribution';
import DocumentData from '../utils/Interface/DocumentData';
import AttributionDataDoc from '../utils/Interface/AttributionDataDoc';
import User from '../utils/Interface/User';
import { DocumentCategory } from '../utils/Interface/DocumentCategory';
import { DocumentModel } from '../utils/Interface/DocumentModel';
import Materiel from "../utils/Interface/Materiel";
import AttributionMin from '../utils/Interface/AttributionMin';
import useSpecialToken from '../utils/hooks/useSpecialToken';
import apiRoutes from '../utils/hooks/apiRoutes';
import apiGLPIRoutes from '../utils/hooks/apiGLPIRoutes';

import InputField from '../components/InputField';
import Header from "../components/Header";
import Button from "../components/Button";
import TableComplexeBis from '../components/TableComplexeBis';
import TableComplexeDocument from "../components/TableComplexeDocument";
import Menu from "../components/Menu";
import InputSelect from '../components/InputSelect';
import EditDocument from '../components/EditDocument';
import PopUp from '../components/PopUp';
import EditAttribution from '../components/EditAttribution';
import NewAttribution from '../components/NewAttribution';

import "../style/css/editdocumentsusers.css";


const EditDocumentUsers: React.FC = () => {

  const [data, setData] = useState<Attribution[]>([]);
  const [data2, setData2] = useState<Attribution[]>([]);
  const [filteredData, setFilteredData] = useState<Attribution[]>([]);
  const [filteredData2, setFilteredData2] = useState<Attribution[]>([]);
  const [dataDoc, setDataDoc] = useState<DocumentData[]>([]);
  const [basicModal, setBasicModal] = useState(false);
  const [selectedAttributionId, setSelectedAttributionId] = useState<number | null>(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(null);
  const [selectedAttributionType, setSelectedAttributionType] = useState('');
  const [selectedAttributionUserId, setSelectedAttributionUserId] = useState('');
  const [selectedAttributionUserName, setSelectedAttributionUserName] = useState('');
  const [selectedAttributionUserFirstName, setSelectedAttributionUserFirstName] = useState('');
  const [selectedAttributionUserEmail, setSelectedAttributionUserEmail] = useState('');
  const [selectedAttributionEntity, setSelectedAttributionEntity] = useState('');
  const [selectedAttributionSerial, setSelectedAttributionSerial] = useState<string>('');
  const [selectedAttributionModel, setSelectedAttributionModel] = useState<string>('');
  const [selectedAttributionCommentary, setSelectedAttributionCommentary]= useState<string>('');
  const [dataCat, setDataCat] = useState<DocumentCategory[]>([]);
  const [dataMod, setDataMod] = useState<DocumentModel[]>([]);
  const [selectedMateriel, setSelectedMateriel] = useState<Materiel | null>(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
  const [selectedModelContent, setSelectedModelContent] = useState<string | null>(null);
  const [selectedUserData, setSelectedUserData] = useState<User | null>(null);
  const [selectedUserName, setSelectedUserName] = useState<string | null>("");
  const [selectedUserFirstName, setSelectedUserFirstName] = useState<string | null>("");
  const [selectedUserEmail, setSelectedUserEmail] = useState<string>("");
  const [selectedModelDocName, setSelectedModelDocName] = useState<string | null>(null);
  const [selectedUserEntityName, setSelectedUserEntityName] = useState<string |null>("")
  const [optXlModal, setOptXlModal] = useState(false);
  const [optXlModal2, setOptXlModal2] = useState(false);

  const [checkedAttributions, setCheckedAttributions] = useState<number[]>([]);
  const [attributions, setAttributions] = useState<AttributionMin[]>([]);
  const [attributionFields, setAttributionFields] = useState<JSX.Element[]>([]);
  const [selectedAttributions, setSelectedAttributions] = useState<AttributionMin[]>([]);
  const [isSelected, setIsSelected] = useState(false);
  const optionsa = dataCat.map(category => ({ text: category.name, id: category.id }));
  const options2 = [    { text: 'Tout voir', id:0},
    { text: '7 derniers jours', id:1},
    { text: 'Dernier mois', id:2 },
    { text: 'Dernière année', id:3},
  ];
  const [selectedDocumentOption, setSelectedDocumentOption] = useState(options2[0].text);
  
  const [selectedAttributionOption, setSelectedAttributionOption] = useState(options2[0].text);

  //check userId

  const { userId } = useParams<{ userId: string }>();
  const userIdNumber = userId ? parseInt(userId, 10) : NaN;
    if (isNaN(userIdNumber)) {
      window.location.href = '/error';
  } 

  //check token
  const { userName, specialToken } = useSpecialToken();

  //useEffect, ftech & filter data

  useEffect(() => {
    if (!isTokenPresent()) {
      window.location.href = '/';
    } else

    if (!specialToken) {
      return; 
    } else {

    fetchData(apiRoutes.attributionsGetAll, (data) => filterAttributionData(data, userIdNumber,selectedAttributionOption), setData, setFilteredData);
    fetchData(apiRoutes.attributionsGetAll, (data) => filterAttributionData2(data, userIdNumber,selectedAttributionOption), setData2, setFilteredData2);
    fetchData(apiRoutes.documentsGetAll, (data) => filterDocumentData(data, userIdNumber, selectedDocumentOption), setDataDoc);
    fetchDataCategories();
    fetchDataUser()
  }

  }, [selectedDocumentOption, selectedAttributionOption, specialToken, checkedAttributions]);


  // functions fetch data
  const fetchData = async (

    url: string,
    filterFunction: (data: any) => any,
    setData: React.Dispatch<React.SetStateAction<any>>,
    setFilteredData?: React.Dispatch<React.SetStateAction<any>>,   
 
) => {

    try {

      if (!specialToken) {
        throw new Error('Special token is null or undefined');
    }
    
    const headers = {
      'Content-Type' : 'application/json',
      'special-token': specialToken
    }
  
    const response = await fetch(url, {headers});

    if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
    }

    const jsonData = await response.json();

     
    const filtered = filterFunction(jsonData);
    setData(filtered);
    

    if (setFilteredData) setFilteredData(filtered);

    if (jsonData.phone_serial) {
        setSelectedAttributionType('Phone')
        setSelectedAttributionType('Phone');
        setSelectedAttributionSerial(jsonData.phone_serial);
        setSelectedAttributionModel(jsonData.phone_model);
        setSelectedMateriel({
          id: jsonData.glpi_phones_id,
          phone_id:jsonData.glpi_phones_id,
          serial: jsonData.phone_serial,
          name: " ",
          user_id: jsonData.user_id,
          usermails_id: jsonData.user_email
      })
 
    } else if (jsonData.computer_serial) {
        setSelectedAttributionType('Computer');
        setSelectedAttributionSerial(jsonData.computer_serial);
        setSelectedAttributionModel(jsonData.computer_model);
        setSelectedMateriel({
          id: jsonData.glpi_computer_id,
          serial: jsonData.computer_serial,
          computer_id:jsonData.glpi_computer_id,
          name: "",
          user_id: jsonData.user_id,
          usermails_id: jsonData.user_email
      })
    } else if (jsonData.monitor_serial) {
        setSelectedAttributionType('Monitor')
        setSelectedAttributionType('Monitor');
        setSelectedAttributionSerial(jsonData.monitor_serial);
        setSelectedAttributionModel(jsonData.monitor_model);
        setSelectedMateriel({
          id: jsonData.glpi_monitors_id,
          monitor_id: jsonData.glpi_monitors_id,
          serial: jsonData.computer_serial,
          name: "",
          user_id: jsonData.user_id,
          usermails_id: jsonData.user_email
      })
    }

    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }

  };


  const fetchDataUser = async () => {

    if (!specialToken) {
      throw new Error('Special token is null or undefined');
    }

    const headers = {
      'Content-Type': 'application/json',
      'special-token': specialToken
    };


    const getOneUrl = apiRoutes.UsersGetOne.replace(':id', `${userIdNumber}`);

    const response = await fetch(getOneUrl, {headers});

    if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }

    const jsonData = await response.json();

    setSelectedUserData(jsonData);
    console.log(selectedUserData);
    setSelectedUserName(jsonData.user_realname);
    setSelectedUserFirstName(jsonData.user_firstname);
    setSelectedUserEmail(jsonData.user_email);
    setSelectedUserEntityName(jsonData.entity_name)

  }

  const filterAttributionData = (data: Attribution[], userIdNumber: number, selectedOption: string): Attribution[] => {
    const now = new Date();
    
    const filteredData = data.filter(attribution =>
      attribution.glpi_user_id === userIdNumber &&
      attribution.state !== undefined &&
      attribution.state !== null &&
      attribution.state !== 'document créé'
    );
  
    switch (selectedOption) {
      case '1':
        const sevenDaysAgo = new Date(now);
        sevenDaysAgo.setDate(now.getDate() - 7);
        return filteredData.filter(attribution => new Date(attribution.attribution_date) >= sevenDaysAgo);
      case '2':
        const lastMonth = new Date(now);
        lastMonth.setMonth(now.getMonth() - 1);
        return filteredData.filter(attribution => new Date(attribution.attribution_date) >= lastMonth);
      case '3':
        const lastYear = new Date(now);
        lastYear.setFullYear(now.getFullYear() - 1);
        return filteredData.filter(attribution => new Date(attribution.attribution_date) >= lastYear);
      case '0':
      default:
        return filteredData;
    }
  };


  const filterAttributionData2 = (data2: Attribution[], userIdNumber: number, selectedOption: string): Attribution[] => {
    const now = new Date();
  
    switch (selectedOption) {
      case '1':
        const sevenDaysAgo = new Date(now);
        sevenDaysAgo.setDate(now.getDate() - 7);
        return data2.filter(attribution =>
          attribution.glpi_user_id === userIdNumber &&
          new Date(attribution.attribution_date) >= sevenDaysAgo
        );
      case '2':
        const lastMonth = new Date(now);
        lastMonth.setMonth(now.getMonth() - 1);
        return data2.filter(attribution =>
          attribution.glpi_user_id === userIdNumber &&
          new Date(attribution.attribution_date) >= lastMonth
        );
      case '3':
        const lastYear = new Date(now);
        lastYear.setFullYear(now.getFullYear() - 1);
        return data2.filter(attribution =>
          attribution.glpi_user_id === userIdNumber &&
          new Date(attribution.attribution_date) >= lastYear
        );
      case '0':
      default:
        return data2.filter(attribution =>
          attribution.glpi_user_id === userIdNumber
        );
    }
  };

  const filterDocumentData = (data: DocumentData[], userIdNumber: number, selectedOption: string): DocumentData[] => {
    const now = new Date();
  
    // Filtrer les documents de l'utilisateur
    const userDocuments = data.filter(doc => doc.user_id === userIdNumber && doc.is_deleted !== 1);
  
    // Filtrer les documents en fonction de l'option sélectionnée
    switch (selectedOption) {
      case '1':
        const sevenDaysAgo = new Date(now);
        sevenDaysAgo.setDate(now.getDate() - 7);
        return userDocuments.filter(doc => {
          const documentDate = new Date(doc.document_date);
          return documentDate >= sevenDaysAgo;
        });
      case '2':
        const lastMonth = new Date(now);
        lastMonth.setMonth(now.getMonth() - 1);
        return userDocuments.filter(doc => {
          const documentDate = new Date(doc.document_date);
          return documentDate >= lastMonth;
        });
      case '3':
        const lastYear = new Date(now);
        lastYear.setFullYear(now.getFullYear() - 1);
        return userDocuments.filter(doc => {
          const documentDate = new Date(doc.document_date);
          return documentDate >= lastYear;
        });
      case '0':
      default:
        return userDocuments;
    }
  };


  async function fetchDataCategories(): Promise<void> {
    try {
      const response = await fetch(apiRoutes.documentsCategoriesGetAll);
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }
      const jsonDataCat = await response.json();
   console.log('jsonDataCat', jsonDataCat)
   setDataCat(jsonDataCat)
   setSelectedCategoryId(jsonDataCat[0].id)
   console.log('selectedCategoryId', selectedCategoryId)
   fetchDataModels(jsonDataCat[0].id)
   console.log()
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
   
  }

  async function fetchDataModels(categoryId: number): Promise<void> {


    // Check if selectedAttributionId is defined and a valid number
    if (!categoryId) {
      throw new Error('ID d\'attribution non valide');
    }


    const getByCatUrl = apiRoutes.documentsModelsByCat.replace(':categoryId', `${categoryId}`);




  
  try {
    const response = await fetch(getByCatUrl);
    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des données');
    }
    const jsonDataMod = await response.json();
   
    setSelectedModelContent(jsonDataMod[0].content)
    setSelectedModelDocName(jsonDataMod[0].name)
    setDataMod(jsonDataMod);
    console.log(jsonDataMod)
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
  }
  }

 // functions filter data

  const handleDocumentsFilterChange = (newValue: string) => {
  setSelectedDocumentOption(newValue);
  };

  const handleAttributionsFilterChange = (newValue: string) => {
  setSelectedAttributionOption(newValue);
  };

  async function generatePdf(): Promise<void> {
    const token = localStorage.getItem('sessionToken');
    if (!token) {
        throw new Error('Token not found in local storage');
    }

  
    const documentData: AttributionDataDoc = {
        user_id: userId || "",
        user_name: selectedUserName || "",
        user_firstname: selectedUserFirstName || "",
        user_email: selectedUserEmail || "",
        entity_name: selectedUserEntityName || "",
        attributions: attributions.map(attribution => ({
            attribution_id: attribution.attribution_id,
            entity_name: attribution.entity_name,
            model_name: attribution.model_name,
            materiel_serial: attribution.materiel_serial,
            author_name: "Si Plus Tech",
            type: attribution.type,
        })),
        modelText: selectedModelContent ? selectedModelContent.replace(/\n/g, ' ') : '',
        modelDocName: selectedModelDocName || 'Modele name',
        commentary: selectedAttributionCommentary
    };

    console.log(documentData, "documentData");
    try {
       
        const response = await fetch(apiRoutes.documentsPost, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'special-token': specialToken || ''
            },
            body: JSON.stringify({ ...documentData, token }), 
        });

        if (!response.ok) {
            throw new Error('Erreur lors de la génération du PDF');
        }

       
        const responseData = await response.json();
        console.log(responseData);
        const documentId = responseData.documentId;

        const response2 = await fetch(apiGLPIRoutes.documentGetOne.replace(':documentId', documentId), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Session-Token': token,
                'Accept': 'application/octet-stream',
            },
        });

        if (!response2.ok) {
            throw new Error('Erreur lors de la récupération des données');
        }

        const blob = await response2.blob();

        const url = window.URL.createObjectURL(blob);

        window.open(url, '_blank');

        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 10000);

        window.location.href = `/inventaire/utilisateurs/${userId}`;
    } catch (error) {
        console.error('Erreur lors de la génération ou de la récupération du PDF :', error);
    }
  }

  const handleDelete = async () => {
  const token = localStorage.getItem('sessionToken');
  if (!token) {
    throw new Error('Token not found in local storage');
  }

  try {

    // Check if selectedAttributionId is defined and a valid number
    if (!selectedAttributionId || isNaN(selectedAttributionId)) {
      throw new Error('ID d\'attribution non valide');
    }


    const deleteUrl = apiRoutes.attributionsDelete.replace(':id', `${selectedAttributionId}`);




    // Send DELETE request
    const response = await fetch(deleteUrl, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });



    // Check if the request was successful
    if (!response.ok) {
      throw new Error('Erreur lors de la suppression de l\'attribution');
    }

// 2. Send glpi_user_id to the appropriate table via the GLPI API
const bodyData = JSON.stringify({ "input": { "glpi_user_id": 5 }});


if (selectedMateriel && selectedAttributionType) {
  let url;
  switch (selectedAttributionType) {
      case 'Computer':
          url = apiGLPIRoutes.computerPut.replace(':materielId', `${selectedMateriel.id}`);
          break;
      case 'Phone':
          url = apiGLPIRoutes.phonePut.replace(':materielId',  `${selectedMateriel.id}`);
          break;
      case 'Monitor':
          url = apiGLPIRoutes.monitorPut.replace(':materielId',  `${selectedMateriel.id}`);
          break;
      default:
          throw new Error('Invalid attribution type');
  }

  const responseGLPI = await fetch(url, {
      method: 'PUT',
      headers: {
          'Content-Type': 'application/json',
          'Session-Token': token,
      },
      body: bodyData,
  });


  if (!responseGLPI.ok) {
      throw new Error('Erreur lors de l\'envoi du glpi_user_id vers l\'API GLPI');
  }
}

alert('Attribution supprimée avec succès')
    // Redirect to the homepage after saving
 window.location.href=`/inventaire/utilisateurs/${selectedAttributionUserId}`

  } catch (error) {
    // Handle errors
    console.error('Erreur lors de la suppression de l\'attribution :', error);
    // Show an error message to the user or log the error to the console
  }
  };

  const handleCheckClick = (
    attribution_id: number,
    type: string,
    entity_name: string,
    model_name: string,
    materiel_serial: string,
    user_name : string,
    
  ) => {
    setAttributions(prevAttributions => {
      const isChecked = prevAttributions.some(attr => attr.attribution_id === attribution_id);

      if (!isChecked) {
        const newAttribution: AttributionMin = {
          attribution_id,
          type,
          entity_name,
          model_name,
          materiel_serial, 
          author_name: "SI plus",
        
        };
        const newAttributions = [...prevAttributions, newAttribution];
        setSelectedAttributions(newAttributions); // Mettre à jour les attributions sélectionnées
        console.log(newAttributions, "newAttributions");
        addAttributionField(attribution_id, type, user_name, entity_name, materiel_serial, model_name,  );
        return newAttributions;
      } else {
        const newAttributions = prevAttributions.filter(attr => attr.attribution_id !== attribution_id);
        setSelectedAttributions(newAttributions); // Mettre à jour les attributions sélectionnées
        console.log(newAttributions);
        removeAttributionField(attribution_id);
        return newAttributions;
      }
    });
    setIsSelected(true)
  };


  const addAttributionField = (attribution_id: number,
    type: string,
    user_name: string,
    entity_name: string,
    model_name: string,
    materiel_serial: string,
   
    ) => {
    const newFields = (
      <div key={attribution_id} className="mainnewdoc__box1__container__lay__1__table1__table__form__input maineditatt__form__inputs"  >
       
        <InputField
          labels={[{ title: 'Type' }]}
          onChange={(newValue) => setSelectedAttributionType(newValue[0])}
          initialValue={[type]}
          readOnly={true}
        />
          <InputField 
          labels={[{ "title":"User " }]} 
          onChange={(newValue) => setSelectedAttributionUserName(newValue[0])} 
          initialValue={[user_name]} 
          readOnly={true} />

          <InputField 
          labels={[{ "title": "Entité" }]} 
          onChange={(newValue) => setSelectedAttributionEntity(newValue[0])} 
          initialValue={[entity_name]} 
          readOnly={true} />

          <InputField 
          labels={[{ "title": "N° Série" }]}
           onChange={(newValue) => setSelectedAttributionSerial(newValue[0])} 
           initialValue={[materiel_serial]} 
           readOnly={true} 
           />

          <InputField 
          labels={[{ "title": "Modèle" }]} 
          onChange={(newValue) => setSelectedAttributionModel(newValue[0])} 
          initialValue={[model_name]}
           readOnly={true} />

          <InputField 
          labels={[{ "title": "Commentaire" }]} 
          onChange={(newValue) => setSelectedAttributionCommentary(newValue[0])} 
          initialValue={[selectedAttributionCommentary]} 
          readOnly={false} />

  
      </div>
    );
    setAttributionFields((prevFields) => [...prevFields, newFields]);
  };
  
  const removeAttributionField = (attribution_id: number) => {
    setAttributionFields((prevFields) =>
      prevFields.filter((field) => field.key !== String(attribution_id))
    );
  };
    
// manage modal
  const toggleOpen = (id: number | null = null) => {
  setSelectedDocumentId(id);
  setBasicModal(!basicModal);
  };

  const toggleOpenxl = () => setOptXlModal(!optXlModal);

  const handleEditClick = (attribution_id: number) => {
  setSelectedAttributionId(attribution_id);
  toggleOpenxl();
  };

  


const handleSelectCategory = (categoryId: number) => {

  const selectedCategory = dataCat.find(category => category.id === categoryId);
  console.log(selectedCategory)
  if (selectedCategory){
  setSelectedCategoryId(selectedCategory?.id);
fetchDataModels(selectedCategory?.id);}
}
  const handleSelectModel = (modelId: number) => {

    const selectedModel = dataMod.find(model => model.id === modelId);

    if (selectedModel) {

      setSelectedModelContent(selectedModel.content);
      setSelectedModelDocName(selectedModel.name);
    } else {
      setSelectedModelContent(null);
      setSelectedModelDocName(null);
    }


  };


  const handleLignClickDoc = (user_id: number) => {
    console.log('')
  }

  const toggleOpen2 = () => setOptXlModal2(!optXlModal2);

  return (

    <div className="maineditdocuser" >

      <div className="maineditdocuser__box1">

        <Header userName={userName}/>

        <div className="maineditdocuser__box1__container">

          <div className="maineditdocuser__box1__container__banner">
            
            <h4> Gestion documents {`${selectedUserFirstName} ${selectedUserName}`}</h4>
        
          </div>

          <div className='maineditdocuser__box1__container__table'>

            <div className='maineditdocuser__box1__container__table__1'>

              <h4 className='maineditdocuser__box1__container__table__1__title'> Attributions en attente de documents</h4>

              <InputSelect 
              selectedKey={6}
              options={options2} 
              onChange={newValue => handleAttributionsFilterChange(String(newValue))} 
              classValue={1} /> 

            </div>
        
            <TableComplexeBis 
            attributions={filteredData} 
            textaction='Modifier' 
            onClick={handleEditClick} 
            onCheckClick={handleCheckClick}
            Visible={true}/>
     
            <MDBModal open={optXlModal} tabIndex='-1' onClose={() => setOptXlModal(false)}>
              <MDBModalDialog size='xl' className='modalxl'>
                <MDBModalContent className='modalxl' id="contentm">
                  <MDBModalHeader>
                    <MDBModalTitle>Modifier une attribution</MDBModalTitle>
                    <MDBBtn 
                  className='btn-close' 
                  color='none' 
                  onClick={toggleOpenxl}>
                    </MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody> 
                    <EditAttribution attributionIdNumber={selectedAttributionId ||0} location={`/inventaire/utilisateurs/${userId}`} handleCancel={() => setOptXlModal(false)}/>
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>

            <div className="mainnewdoc__box1__container__lay__1__table1__table__form" >

              <h4 className="mainnewdoc__box1__container__lay__1__table1__table__form__title">Champs informations pour créer un document </h4>  

              {attributionFields.map((field, index) => (
              <div className="mainnewdoc__box1__container__lay__1__table1__table__form__input maineditatt__form__inputs"  key={index}>{field} </div> ))}
            
              <div className="mainnewdoc__box1__container__lay__1__table1__table__form__inputselect">

                <InputSelect
                selectedKey={7}
                options={optionsa}
                onChange={(categoryId: number) => handleSelectCategory(categoryId)}
                classValue={1}/>
             
                <InputSelect
                selectedKey={8}
                options={dataMod.map(model => ({ text: model.name, id: model.id }))}
                onChange={(modelId: number) => handleSelectModel(modelId)}
                classValue={1}/>

              </div>

            </div>

            <div className="mainnewdoc__box1__container__lay__1__table1__table__form__btns">

              <PopUp 
              onDeleteClick={handleDelete}/>

              <div className={`containerX ${isSelected ? "selected-container" : ""}`}>
                          <Button 
                          btnName="Générer un document lié" 
                          onClick={generatePdf}
                          disable={!isSelected}
                          />

                    



              </div>

              <Button 
                          btnName="Nouvelle attribution" 
                          onClick={toggleOpen2}
                          disable={false} />


              <MDBModal MDBModal open={optXlModal2} tabIndex='-1' onClose={() => setOptXlModal2(false)}>
                <MDBModalDialog size='xl' >
                  <MDBModalContent id="contentm">
                    <MDBModalHeader>
                      <MDBModalTitle>Nouvelle attribution</MDBModalTitle>
                      <MDBBtn className='btn-close' color='none' onClick={toggleOpen2}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <NewAttribution isUserAlreadySelected={true} User={selectedUserData} handleCancel={() => setOptXlModal2(false)} location={`/inventaire/utilisateurs/${userId}`}/>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>

              </div>

          </div>

          <div className='maineditdocuser__box1__container__table'> 

            <div className='maineditdocuser__box1__container__table__1'>
            
              <h4 className='maineditdocuser__box1__container__table__1__title'> Documents liés à l'utilisateur</h4>

              <InputSelect 
              selectedKey={9}
              options={options2}
              onChange={newValue => handleDocumentsFilterChange(String(newValue))} 
              classValue={1}/>

            </div>   

            <TableComplexeDocument 
            documents={dataDoc} 
            textaction='Modifier' 
            onEdit={toggleOpen} 
            Present={1}
            onLignClick={handleLignClickDoc}
            response={false}/>

            <MDBModal open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-2'>
              <MDBModalDialog>
                <MDBModalContent id='contentl'>
                  <MDBModalHeader >
                    <MDBModalTitle > Gérer le document </MDBModalTitle>
                    <MDBBtn 
                    className='btn-close' 
                    color='none' 
                    onClick={() => { setBasicModal(false); window.location.reload();}}> 
                    </MDBBtn> 
                  </MDBModalHeader>
                  <MDBModalBody >
                   <EditDocument documentId={selectedDocumentId ?? 0}/>      
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
      
          </div>

          <div className='maineditdocuser__box1__container__table'>

            <div className='maineditdocuser__box1__container__table__1'>

              <h4 className='maineditdocuser__box1__container__table__1__title'> Toutes les attributions de l'utilisateurs</h4>

              <InputSelect 
              selectedKey={10}
              options={options2} 
              onChange={newValue => handleAttributionsFilterChange(String(newValue))} 
              classValue={1} /> 

            </div>
        
            <TableComplexeBis 
            attributions={filteredData2} 
            textaction='Modifier' 
            onClick={handleEditClick} 
            onCheckClick={handleCheckClick}
            Visible={false}/>
     
            <MDBModal open={optXlModal} tabIndex='-1' onClose={() => setOptXlModal(false)}>
              <MDBModalDialog size='xl' className='modalxl'>
                <MDBModalContent className='modalxl' id="contentm">
                  <MDBModalHeader>
                    <MDBModalTitle>Modifier une attribution</MDBModalTitle>
                    <MDBBtn 
                  className='btn-close' 
                  color='none' 
                  onClick={toggleOpenxl}>
                    </MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody> 
                    <EditAttribution attributionIdNumber={selectedAttributionId ||0} location={`/inventaire/utilisateurs/${userId}`} handleCancel={() => setOptXlModal(false)}/>
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>

          </div>

      </div>
      
      </div>

      <div className="maineditdocuser__menu">

        <Menu/>

      </div>

    </div>
  );
  }

export default EditDocumentUsers;